import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Tarce'; // Default title for the application
  navOpen = false;
  isLoginPage = false;

  constructor(private router: Router) {}

  ngOnInit() {
    // Check initial route
    this.isLoginPage = this.router.url === '/login';
    
    // Listen to route changes to detect login page
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.isLoginPage = event.url === '/login';
    });
  }
}